import React from "react";
import PropTypes from "prop-types";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";

const useStyle = makeStyles(theme => ({
  inline: {
    display: "flex",
  },
  value: {
    fontWeight: "bold",
    width: "100%",
    fontSize: "16px",
    minWidth: "150px",
    margin: "auto",
  },
  size: {},
  spacer: {
    flex: "1 1 100%",
  },
  filler: {
    minWidth: theme.spacing(6),
    height: theme.spacing(6),
  },
}));

const EmailTicketSystemTableSelectorCell = ({ value, onClickUp, onClickDown, onClickDelete }) => {
  const classes = useStyle();
  return (
    <Card>
      <CardContent>
        <div className={`${classes.inline} ${classes.size}`}>
          <div className={classes.value}>{value}</div>
          <div className={classes.spacer} />
          {onClickUp && (
            <Tooltip title="Sort To Left">
              <IconButton aria-label="left" onClick={() => onClickUp()}>
                <ArrowDropUpIcon />
              </IconButton>
            </Tooltip>
          )}
          {onClickDown ? (
            <Tooltip title="Sort To Right">
              <IconButton aria-label="right" onClick={() => onClickDown()}>
                <ArrowDropDownIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <div className={classes.filler} />
          )}
          {onClickDelete && (
            <Tooltip title="Delete">
              <IconButton aria-label="delete" onClick={() => onClickDelete()}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

EmailTicketSystemTableSelectorCell.defaultProps = {
  onClickDown: undefined,
  onClickUp: undefined,
  onClickDelete: undefined,
};

EmailTicketSystemTableSelectorCell.propTypes = {
  onClickUp: PropTypes.func,
  onClickDown: PropTypes.func,
  value: PropTypes.string.isRequired,
  onClickDelete: PropTypes.func,
};

export default EmailTicketSystemTableSelectorCell;
